export default __webpack_public_path__ + "assets/png/49526a7f9d0d9f94adf7d6873a0b451a.png";